<template>
  <div>
    <section class="content">
      <ul v-if="details != ''">
        <li>
          <label>类型：</label>
          <p v-show="details.type == 1">公司</p>
          <p v-show="details.type == 2">个人</p>
        </li>
        <br />
        <li>
          <label>公司名称：</label>
          <p>{{ details.name }}</p>
        </li>
        <br />
        <li>
          <label>地址：</label>
          <p>{{ details.company_address }}</p>
        </li>
        <li>
          <label>纳税人识别号：</label>
          <p>{{ details.taxpayer }}</p>
        </li>
        <li>
          <label>联系人姓名：</label>
          <p>{{ details.contact_name }}</p>
        </li>
        <li>
          <label>联系人手机号：</label>
          <p>{{ details.contact_phone }}</p>
        </li>
        <li>
          <label>账号数：</label>
          <p>{{ details.entry_count }}</p>
        </li>
        <li>
          <label>状态：</label>
          <p v-show="details.sign_status == 2">已签约</p>
          <p v-show="details.sign_status == 1">未签约</p>
        </li>
        <li>
          <label>个人身份证号码：</label>
          <p>{{ details.idcard }}</p>
        </li>
        <li>
          <label>银行名称：</label>
          <p>{{ details.bank_name }}</p>
        </li>
        <li>
          <label>支行名称：</label>
          <p>{{ details.bank_branch }}</p>
        </li>
        <li>
          <label>银行账号：</label>
          <p>{{ details.bank_no }}</p>
        </li>
        <br />
        <li style="width: 100%">
          <label>合作项目：</label>
          <p>{{ details.project_names }}</p>
        </li>
      </ul>
    </section>
    <section class="list" v-show="recordList != ''">
      <h2>编辑记录</h2>
      <a-timeline>
        <a-timeline-item
          color="green"
          v-for="(element, b) in recordList"
          :key="b + 'c'"
        >
          <h3>
            <span v-show="element.type == 1">公司</span>
            <span v-show="element.type == 2">个人</span>
            <span v-show="element.type == 1">
              {{ "&nbsp;&nbsp;" + element.name }}
            </span>
            <span v-show="element.type == 2">
              {{ "&nbsp;&nbsp;" + element.contact_name }}
            </span>
          </h3>
          <ul class="list-info">
            <li>
              <label>地址：</label>
              <p>{{ element.company_address }}</p>
            </li>
            <li>
              <label>纳税人识别号：</label>
              <p>{{ element.taxpayer }}</p>
            </li>
            <li>
              <label>联系人姓名：</label>
              <p>{{ element.contact_name }}</p>
            </li>
            <li>
              <label>联系人手机号：</label>
              <p>{{ element.contact_phone }}</p>
            </li>
            <li>
              <label>账号数：</label>
              <p>{{ element.entry_count }}</p>
            </li>
            <li>
              <label>状态：</label>
              <p v-show="element.sign_status == 2">已签约</p>
              <p v-show="element.sign_status == 1">未签约</p>
            </li>
            <li>
              <label>个人身份证号码：</label>
              <p>{{ element.idcard }}</p>
            </li>
            <li>
              <label>银行名称：</label>
              <p>{{ element.bank_name }}</p>
            </li>
            <li>
              <label>支行名称：</label>
              <p>{{ element.bank_branch }}</p>
            </li>
            <li>
              <label>银行账号：</label>
              <p>{{ element.bank_no }}</p>
            </li>
            <br />
            <li style="width: 100%">
              <label>合作项目：</label>
              <p>{{ element.project_names }}</p>
            </li>
            <br />
            <li>
              <label>操作人：</label>
              <p>{{ element.create_user_name }}</p>
            </li>
            <li>
              <label>操作时间：</label>
              <p>{{ element.update_time }}</p>
            </li>
          </ul>
        </a-timeline-item>
      </a-timeline>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      details: "",
      recordList: ""
    };
  },
  props: {
    thirdDetailsVal: {}
  },
  watch: {
    thirdDetailsVal() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.thirdDetailsVal != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.thirdDetailsVal;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartRecordData";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_third_part_id: this.details.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.recordList = res.data.data;
            // console.log(this.recordList);
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 30px 4%;
  > ul {
    > li {
      display: inline-block;
      width: 33.3%;
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        vertical-align: top;
      }
      p {
        max-width: 80%;
      }
    }
  }
}
.list {
  margin: 0 4%;
  h2 {
    font-style: normal;
    margin: 20px 0;
    color: #666;
  }
  .list-info {
    > li {
      display: inline-block;
      width: 33.3%;
      vertical-align: top;
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        vertical-align: top;
      }
      p {
        max-width: 80%;
      }
    }
  }
}
</style>
